<!--
  @Author 22030124/xieyq
  @Date 2023-10-19 10:12:26
  @Description 组件 =》人员输入选择框
-->
<template>
  <div :class="scope.clsPrefix">
    <!-- 下拉框 -->
    <el-select
      ref="select"
      :class="`${scope.clsPrefix}_select`"
      :value="value"
      size="small"
      :multiple="multiple"
      filterable
      remote
      :valueKey="valueKey"
      :disabled="disabled"
      :collapse-tags="collapseTags"
      :placeholder="$t('common.inputKeyword')"
      :remote-method="remoteMethod"
      clearable
      :loading="loading"
      @blur="handleBlur"
      @change="handleChange">
      <el-option
        v-for="item in options"
        :key="item.userEmpsn"
        :label="`${item.name}(${item.userEmpsn})`"
        :value="item">
      </el-option>
    </el-select>
    <!-- 搜索按钮 -->
    <el-button icon="el-icon-search" :class="`${scope.clsPrefix}_search`" @click="triggerSelect"></el-button>
    <!-- 人员选择弹窗 -->
    <cosmo-select-user-dialog
      v-if="!disabled"
      ref="selectDialog"
      :multiple="multiple"
      :tagLabel="label"
      :valueKey="valueKey"
      :is-inner="isInner"
      :normalizer="normalizer"
      :disabled-keys="disabledKeys"
      :currentUserEmpsn="currentUserEmpsn"
      @submit="submit"
    />
  </div>
</template>

<script>
// 加载
import { Select, Option, Button } from 'element-ui'
// 用户选择弹层
import CosmoSelectUserDialog from './dialog.vue'
// 公共混入js
import CommonMixins from './common.js'
export default {
  // 组件名称
  name: 'CosmoSelectUser',
  components: {
    CosmoSelectUserDialog,
    ElSelect: Select,
    ElOption: Option,
    ElButton: Button
  },
  // 混入
  mixins: [CommonMixins],
  props: {
    // 是否收起
    collapseTags: {
      type: Boolean
    }
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'cosmo-select-user'
      },
      // 是否正在加载
      loading: false,
      // 下拉选项
      options: [],
      // 查询的合计
      total: 0,
      // 查询的条数
      pageSize: 10
    }
  },
  watch: {
    value(newVal) {
      // 更新options
      this.updateOptions(newVal)
    }
  },
  // 创建完成
  created() {
    // 初始化方法
    this.init()
  },
  // 挂载完成
  mounted() {},
  // 方法
  methods: {

    /**
     * 初始化方法
     * @returns {void}
     */
    init() {
      // 远程搜索定时任务
      this.remoteTimmer = null
      // 更新options
      this.updateOptions(this.value)
    },

    /**
     * 获取选择的结果
     * @param {*} val 选择的值
     * @returns {void}
     */
    getResult(val) {
      let result
      // 如果多选
      if (this.multiple) {
        // 结果
        result = val.map(item => {
          // 如果id存在，则说明是组件带的
          if (this.isInner(item)) {
            return this.normalizer(item)
          }
          return item
        })
      } else {
        if (val?.id) {
          result = this.normalizer(val)
        } else {
          result = val
        }
      }
      return result
    },

    /**
     * 处理输入框修改
     * @returns {void}
     */
    handleChange(val) {
      // 获取选择结果
      const result = this.getResult(val)
      this.$emit('input', result)
      // 抛出修改事件
      this.emitChange(result)
    },

    /**
     * 处理失去焦点事件
     * @returns {void}
     */
    handleBlur() {
      // 清楚定时任务
      this.clearTimeout()
    },

    /**
     * 触发选择
     * @returns {void}
     */
    triggerSelect() {
      // 显示弹层
      this.$refs.selectDialog && this.$refs.selectDialog.initDialog(this.value)
    },

    /**
     * 修改
     * @param {*} val
     */
    emitChange(val) {
      // 抛出修改事件
      this.$emit('change', val)
    },

    /**
     * 弹窗确定事件
     * @param {Object} selectedRows 选中的人员信息
     * @returns {void}
     */
    submit(selectedRows) {
      // 获取结果值
      const result = this.getResult(selectedRows)
      // 选中的数据赋值
      this.$emit('input', result)
      // 更新options数据
      this.updateOptions(result)
      // 抛出修改事件
      this.emitChange(result)
      // 抛出select方法
      this.$emit('select', selectedRows)
    },

    /**
     * 更新options列表选项
     * 这里主要是为了弹窗和初始化下拉选有值才能回显
     * @param {Object|Array} value 选中的数据
     * @returns {void}
     */
    updateOptions(value) {
      // 数据不存在，则直接返回
      if (!value) {
        return
      }
      // 参数选项
      const options = Array.isArray(value) ? value : [value]
      const currentOptions = this.options
      // options赋值
      this.options = options.map(item => {
        return {
          name: item[this.label],
          userEmpsn: item[this.valueKey]
        }
      })
      this.$nextTick(() => {
        // 需要切换回去
        this.options = currentOptions
      })
    },

    /**
     * 清楚定时任务
     * @returns {void}
     */
    clearTimeout() {
      if (!this.remoteTimmer) {
        return
      }
      // 如果存在远程定时任务，则清除定时任务
      window.clearTimeout(this.remoteTimmer)
      this.remoteTimmer = null
    },

    /**
     * 远程搜索方法
     * @param {*} query 输入的查询条件
     * @returns {void}
     */
    remoteMethod(query) {
      if (!query) {
        return
      }
      // 清楚定时任务
      this.clearTimeout()
      // 重新定义定时任务
      this.remoteTimmer = setTimeout(() => {
        // 查询条件不为空
        if (query !== '') {
          this.loading = true
          // 查询人员接口
          this.request.requestPersonList({
            page: 1,
            // 查询的条数
            size: this.pageSize,
            // 姓名或工号
            user: query,
            // 是否在岗
            isOnDuty: true
          }).then(({ data }) => {
            // 参数选项
            this.options = data.records
            // 合计赋值
            this.total = data.total
            // 停止加载
            this.loading = false
          }).catch(() => {
            // 停止加载
            this.loading = false
          })
        } else {
          // 下拉选置空
          this.options = []
        }
        // 清楚定时任务
        this.clearTimeout()
      }, 200)
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'cosmo-select-user';
.#{$class-prefix} {
  position: relative;

  // 搜索按钮
  &_search.el-button {
    position: absolute;
    right: 0;
    top: 0;
    border: none;
    padding: 0;
    height: 100%;
    width: 30px;
    font-size: 14px;
    line-height: 32px;
    color: #909399;
    text-align: center;
    background-color: transparent;
  }
  // 下拉选
  &_select {
    width: 100%;
    .el-icon-circle-close {
      margin-right: 16px;
    }
  }
}
</style>
